import React from 'react';
import { Flex } from 'reflexbox';
import { Table, TableHead, TableRow, TableHeader, TableBody, TableData } from 'boss-ui';
import { LinkedText, BlockIcon, TableItemSkeleton } from 'boss-ui';
import styled from 'styled-components';

const TableContainer = styled(Flex)`
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
`;

const RoleLabel = styled.p`
    color: #a5d6a7;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
`;


function DefaultAdminRow({ admin, onRemove, onHover, isHovered }) {
    return (
        <TableRow
            height="41px"
            onMouseOver={() => onHover(admin.userId)}
            onMouseOut={() => onHover(null)}
            borderTransparent="true"
            mouseOver={isHovered}
        >
            <TableData>
                <LinkedText>{admin.displayName}</LinkedText>
            </TableData>
            <TableData>{admin.email}</TableData>
            <TableData><RoleLabel>ADMIN</RoleLabel></TableData>
            <TableData><RoleLabel>{admin.role}</RoleLabel></TableData>
            <TableData>
                <Flex onClick={() => onRemove(admin)}>
                    <BlockIcon />
                </Flex>
            </TableData>
        </TableRow>
    );
}

export default function DefaultAdminTable({ isLoading, filteredAdmins, rowHoverId, setRowHoverId, removeDefaultAdmin }) {
        return (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow height="41px">
                            <TableHeader>User</TableHeader>
                            <TableHeader>Email</TableHeader>
                            <TableHeader>Event Role</TableHeader>
                            <TableHeader>User Role</TableHeader>
                            <TableHeader></TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isLoading && 
                            <TableItemSkeleton numberOfCells={5} />
                        }
                        {!isLoading && filteredAdmins && filteredAdmins.length > 0 && (
                            filteredAdmins.map((item) => (
                                <DefaultAdminRow
                                    key={item.userId}
                                    admin={item}
                                    onRemove={removeDefaultAdmin}
                                    onHover={setRowHoverId}
                                    isHovered={rowHoverId === item.userId}
                                />
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    };